




























































































import {Component, Mixins, Vue} from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts/dist/vue-apexcharts';
import Dinero from 'dinero.js';
import {BvTableFieldArray} from 'bootstrap-vue';
import {ConvertModule, ILocation, ILocationSales, ISales, ISalesSummary, TInterval} from '@/stores/modules/convert';
import * as moment from 'moment-timezone';
import {find, filter, clone} from 'lodash';
import LocationSalesTable from '@/components/LocationSalesTable.vue';
import {WebService} from '@/services/web.service';
import LocationPicker from '@/components/LocationPicker.vue';
import LocationIcon from '../assets/icon-location.svg';

@Component({
	components: {
		apexchart: VueApexCharts,
		LocationSalesTable: LocationSalesTable,
		LocationPicker: LocationPicker,
		LocationIcon: LocationIcon
	},
	computed: {}
})
export default class MyDashboard extends Vue {
	public monthlyChartOptions = {
		colors: ['#fff'],
		stroke: {
			width: [0, 4],
			lineCap: 'round'
		},
		title: {
			show: false
		},
		xaxis: {
			categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			labels: {
				style: {
					colors: new Array(12).fill('#fff'),
					fontSize: '10px',
					fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif'
				},
				formatter(value: string) {
					return value.substr(0, 1);
				}
			},
			axisBorder: {
				show: false
			},
			axisTicks: {
				show: false
			}
		},
		yaxis: {
			show: false,
		},
		floating: true,
		axisTicks: {
			show: false
		},
		axisBorder: {
			show: false
		},
		labels: {
			show: false
		},
		chart: {
			toolbar: {
				show: false
			}
		},
		tooltip: {
			theme: 'dark',
			y: {
				formatter(value: number) {
					return Dinero({
						amount: value
					}).toFormat();
				}
			},
			x: {
				formatter(value: string | number) {
					return value + ' Sales';
				}
			}
		},
		grid: {
			yaxis: {
				lines: {
					show: false
				}
			},
		},
		plotOptions: {
			bar: {
				endingShape: 'rounded'
			}
		},
	};

	public digitalParticipationTiers = [
		{
			max: .2,
			title: 'Bad'
		},
		{
			max: .4,
			title: 'Decent'
		},
		{
			max: .6,
			title: 'OK'
		},
		{
			max: .8,
			title: 'Good'
		},
		{
			max: 1,
			title: 'Great'
		},
	];

	public averageFeedbackTiers = [
		{
			max: 1,
			title: 'Bad'
		},
		{
			max: 2,
			title: 'Decent'
		},
		{
			max: 3,
			title: 'OK'
		},
		{
			max: 4,
			title: 'Good'
		},
		{
			max: 5,
			title: 'Great'
		},
	];

	public weeklyChartOptions = {
		colors: ['#fff', '#1D2833'],
		stroke: {
			width: [0, 1],
			lineCap: 'round'
		},
		markers: {
			colors: '#FACA3F',
			strokeColor: '#1D2833',
			size: 3,
			fillOpacity: 0,
			strokeOpacity: 1
		},
		title: {
			show: false
		},
		xaxis: {
			categories: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
			labels: {
				style: {
					colors: new Array(7).fill('#fff'),
					fontSize: '10px',
					fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif'
				},
				formatter(value: string) {
					return value.substr(0, 1);
				}
			},
			axisBorder: {
				show: false
			},
			axisTicks: {
				show: false
			}
		},
		yaxis: {
			show: false
		},
		floating: true,
		axisTicks: {
			show: false
		},
		axisBorder: {
			show: false
		},
		labels: {
			show: false
		},
		legend: {
			show: false
		},
		chart: {
			toolbar: {
				show: false
			}
		},
		tooltip: {
			theme: 'dark',
			y: {
				formatter(value: number) {
					return Dinero({
						amount: value
					}).toFormat();
				}
			},
			x: {
				formatter(value: string | number) {
					return value + ' Sales';
				}
			}
		},
		grid: {
			yaxis: {
				lines: {
					show: false
				}
			},
		},
		plotOptions: {
			bar: {
				endingShape: 'rounded'
			}
		}
	};

	public GROSS = 'gross';
	public NET = 'net';

	public selectedType: 'gross' | 'net' = 'gross';
	public selectedLocationBase: string | null = null;

	get salesSummary(): ISalesSummary | null {
		return ConvertModule.salesSummary;
	}

	get locations() {
		return ConvertModule.locations;
	}

	get customerEngagement() {
		return ConvertModule.customerEngagementsByLocationBase(this.selectedLocationBase);
	}

	get monthlySeries() {
		return [{
			name: 'Monthly Sales',
			type: 'column',
			// data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160],
			data: this.salesSummary === null ? [] : this.salesSummary.month.currentSales.map((currentSale) => {
				return currentSale[this.selectedType];
			})
		}];
	}

	get selectedLocation(): ILocation | null {
		return find(this.locations, {base: this.selectedLocationBase}) || null;
	}

	get weeklySeries() {
		return [{
			name: 'Current Week',
			type: 'column',
			// data: [440, 505, 414, 671, 227, 413, 201],
			data: this.salesSummary === null ? [] : this.salesSummary.week.currentSales.map((currentSale) => {
				return currentSale[this.selectedType];
			})
		}, {
			name: 'Last Week',
			type: 'line',
			// data: [445, 510, 419, 671, 227, 413, 201],
			data: this.salesSummary === null ? [] : this.salesSummary.week.lastSales.map((lastSale) => {
				return lastSale[this.selectedType];
			})
		}];
	}

	get digitalParticipationTier() {
		return find(this.digitalParticipationTiers, (digitalParticipationTier) => {
			return this.customerEngagement.digitalParticipation <= digitalParticipationTier.max;
		});
	}

	get averageFeedbackTier() {
		return find(this.averageFeedbackTiers, (averageFeedbackTier) => {
			return this.customerEngagement.averageFeedback <= averageFeedbackTier.max;
		});
	}

	getAverageFeedbackBarPercentage(index: number) {
		if(this.customerEngagement.averageFeedback > index) {
			return 100;
		}
		const section = this.customerEngagement.averageFeedback - (index - 1);
		if(section <= 0) {
			return 0;
		}
		return section * 100;
	}

	async mounted() {
		await Promise.all([await WebService.getLocations(), WebService.getSalesSummary(), WebService.getCustomerEngagement()]);
	}

	getSalesByLocationBaseAndInterval(locationBase: string | null, interval: TInterval) {
		return ConvertModule.salesByLocationBaseAndInterval(locationBase, interval);
	}

	async openLocationPicker() {
		this.$bvModal.show('location-picker');
	}

	locationSelected(locationBase: string) {
		this.selectedLocationBase = locationBase;
		WebService.getCustomerEngagement(this.selectedLocationBase);
		this.$bvModal.hide('location-picker');
	}
}
